import React, { useState } from 'react'
import '../index.css'
import Logo from '../assets/logo.png'
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';

const Header = () => {
      const [isOpen, setIsOpen] = useState(false);
  return (
        <header>
            <nav className="homify-nav" id="nav-bar">
                <Link to="/">
                    <a href="/index.html"><img className="logo" src={Logo} alt="Homify Logo" /></a>
                </Link>
            <div className="hamburger" onClick={() => setIsOpen(!isOpen)}>
              <motion.div
                className="line"
                animate={isOpen ? { rotate: 45, y: 7 } : { rotate: 0, y: 0 }}
                transition={{ duration: 0.3 }}
              />
              <motion.div
                className="line"
                animate={isOpen ? { opacity: 0 } : { opacity: 1 }}
                transition={{ duration: 0.3 }}
              />
              <motion.div
                className="line"
                animate={isOpen ? { rotate: -45, y: -7 } : { rotate: 0, y: 0 }}
                transition={{ duration: 0.3 }}
              />
            </div>

                <ul className={isOpen ? 'second-nav show-nav' : 'second-nav'}>
                    <li><a onClick={() => setIsOpen(!isOpen)}  className="dash-anchor" href="#home">HOME</a></li>
                    <li><a onClick={() => setIsOpen(!isOpen)}  className="dash-anchor" href="#services">SERVICES</a></li>
                    <li><a onClick={() => setIsOpen(!isOpen)}  className="dash-anchor" href="#features">FEATURES</a></li>
                    <li><a onClick={() => setIsOpen(!isOpen)}  className="dash-anchor" href="#contact">CONTACT</a></li>
                    <div className= 'show-secondnav' >
                        <Link to="/register">
                            <li className="reg register-button"><a className="dash-anchor" href="./register/register.html" >REGISTER</a></li>
                        </Link>
                        <Link to="/login">
                            <li className="login"><a className="dash-anchor" href="./login-signup/login.html" >LOGIN</a></li> 
                        </Link>
                    </div>
                </ul>
                <ul className="second-nav">
                    <Link to="/register">
                        <li className="reg register-button"><a href="./register/register.html" >REGISTER</a></li>
                    </Link>
                    <Link to="/login">
                        <li className="login"><a href="./login-signup/login.html" >LOGIN</a></li> 
                    </Link>
                </ul>
            </nav> 
        </header>

  )
}

export default Header